import React, { createContext, useContext, useEffect, useState } from "react";
import { ChakraProvider } from "@chakra-ui/react";
import StoreSettingService from "services/store_setting";
import { Toaster, toaster } from "@/components/ui/toaster"
import { Button, CloseButton, Container, Dialog, Portal } from "@chakra-ui/react"
import { Helmet } from "react-helmet";
import { createSystem, defaultBaseConfig, defineConfig, defaultConfig } from "@chakra-ui/react"
const StoreContext = createContext(null);
const service = new StoreSettingService();
const INJECTED_SCRIPT_ATTR = "data-sipro-script";

const clearInjectedScripts = () => {
    document.querySelectorAll(`script[${INJECTED_SCRIPT_ATTR}="1"]`).forEach(node => {
        node.parentNode?.removeChild(node);
    });
};

const appendScriptNode = (scriptNode, scriptId, target) => {
    const node = document.createElement("script");
    Array.from(scriptNode.attributes || []).forEach(attr => {
        node.setAttribute(attr.name, attr.value);
    });
    node.setAttribute(INJECTED_SCRIPT_ATTR, "1");
    node.setAttribute("data-sipro-script-id", scriptId);
    if (scriptNode.textContent) {
        node.text = scriptNode.textContent;
    }
    target.appendChild(node);
};

const injectScriptCode = (script, index) => {
    const code = String(script?.code ?? "").trim();
    if (!code || script?.enabled === false) {
        return;
    }

    const scriptId = script?.id ?? `script_${index}`;
    const position = script?.position === "head" ? "head" : "body_end";
    const target = position === "head" ? document.head : document.body;

    if (code.toLowerCase().includes("<script")) {
        const temp = document.createElement("div");
        temp.innerHTML = code;
        const parsedScripts = temp.querySelectorAll("script");
        if (parsedScripts.length > 0) {
            parsedScripts.forEach(node => appendScriptNode(node, scriptId, target));
            return;
        }
    }

    const inlineNode = document.createElement("script");
    inlineNode.setAttribute(INJECTED_SCRIPT_ATTR, "1");
    inlineNode.setAttribute("data-sipro-script-id", scriptId);
    inlineNode.text = code;
    target.appendChild(inlineNode);
};

const syncScripts = (scripts = []) => {
    if (typeof document === "undefined") {
        return;
    }

    clearInjectedScripts();
    scripts.forEach((script, index) => injectScriptCode(script, index));
};

const system = createSystem(defaultConfig, {

    globalCss: {
        html: {
            colorPalette: "blue",
        },
    },


})
export const StoreProvider = ({ children }) => {

    const [loading, setLoading] = useState(true);
    const [store, setStore] = useState();
    const [themeConfig, setThemeConfig] = useState(system)
    const themeLayout = typeof store?.web?.theme_layout === "string" && store?.web?.theme_layout
        ? store.web.theme_layout
        : "base";

    useEffect(() => {

        loadData();

    }
        , [])



    useEffect(() => {
        const queryParams = new URLSearchParams(window.location.search);
        var ref = queryParams.get("ref")
        if (ref) {
            window.localStorage.setItem("ref_code", ref);
            window.localStorage.setItem("ref_time", (new Date()).getTime())
        }


    }
        , [])




    const handlePostMessage = (event) => {
        var message = event.data.message;
        if (!message)
            return;

        if (message.action === "home_page_changed") {
            // console.log("event   window.addEventListener", { ...store, home_page: message.data })

            setStore({ ...store, home_page: message.data })
        }
    }

    window.addEventListener("message", handlePostMessage);


    useEffect(() => {
        var theme = store?.web?.theme;
        if (!theme) {
            theme = { colorPalette: { name: "blue" } };
        }


        var themeSetting = createSystem(defaultConfig, {
            globalCss: {
                html: {
                    colorPalette: theme.colorPalette.name,
                },
            },
           
        })
        setThemeConfig(themeSetting)


    }, [store])


    useEffect(() => {
        syncScripts(store?.web?.scripts ?? []);
        return () => {
            clearInjectedScripts();
        };
    }, [store?.web?.scripts]);


    const loadData = async () => {
        try {
            var data = await service.getStoreSetting();
            data.web = {
                ...data.web,
                chat_enabled: true,
                theme_layout: typeof data?.web?.theme_layout === "string" && data.web.theme_layout
                    ? data.web.theme_layout
                    : "base",
                full_url: data.web.custom_domain
                    ? (data.web.custom_domain.startsWith('http') ? data.web.custom_domain : `https://${data.web.custom_domain}`)
                    : `https://${data.web.url}.sipro.store`
            }
            setStore(data)

        } catch (error) {

        }
        setLoading(false)

    }



    if (loading) {
        return "";
    }

    if (!store) {
        return "No store"
    }




    const config = defineConfig({
        globalCss: {
            html: {
                colorPalette: "cyan", // Change this to any color palette you prefer
            },
        },
    })

    // const system = createSystem(defaultConfig, config)



    return (
        <StoreContext.Provider value={{ store, themeLayout }}>
            <ChakraProvider value={themeConfig}>
                <Helmet>
                    <title>{store.title}</title>
                </Helmet>

                {children}
            </ChakraProvider>
        </StoreContext.Provider>
    );
};

export const useStore = () => {
    return useContext(StoreContext);
}

export const useThemeLayout = () => {
    const context = useContext(StoreContext);
    return context?.themeLayout || "base";
}